import React from "react";
import { ClipLoader } from "react-spinners";

function Loader({ color = "#36d7b7", size = 20 }) {
    return (
        <span className="loading">
            <ClipLoader color={color} size={size} />
        </span>
    );
}

export default Loader;